import type {
  CompanyFinancialsTrailingPeriod,
  CompanyFinancialsView,
} from '@/services/companies.service'
import { FinancialStatCards } from '@/components/custom/companies/overview/financial-stat-cards'
import { FinancialsTable } from '@/components/custom/companies/financials/financials-table'
import { CompositeMetricChart } from '@/components/custom/companies/financials/composite-metric-chart'
import { CompanyActualVsBudgetViewContainer } from '@/components/custom/companies/financials/actual-vs-budget-view'
import { isActualVsBudgetEnabled } from '@/features/actual-vs-budget-production/access'

interface FinancialsTabProps {
  companyId: string
  initialTrailingPeriod?: CompanyFinancialsTrailingPeriod
  initialView?: CompanyFinancialsView
}

export function FinancialsTab({
  companyId,
  initialTrailingPeriod,
  initialView,
}: FinancialsTabProps) {
  const showActualVsBudget = isActualVsBudgetEnabled(import.meta.env)

  return (
    <div className="space-y-4">
      <section>
        <FinancialStatCards companyId={companyId} surface="financials" />
      </section>

      <CompositeMetricChart key={companyId} companyId={companyId} />

      {showActualVsBudget ? (
        <CompanyActualVsBudgetViewContainer companyId={companyId} />
      ) : null}

      <section>
        <FinancialsTable
          companyId={companyId}
          initialTrailingPeriod={initialTrailingPeriod}
          initialView={initialView}
        />
      </section>
    </div>
  )
}
